import type { ObjectId } from '@freightview/object-id'

import {
  vNonEmptyString,
  vObject,
  vOptional,
  type vOutput,
  vString,
} from '../validation/index.ts'

export const createGLCodeSchema = vObject({
  code: vNonEmptyString(),
  description: vOptional(vString()),
})

export type CreateGLCodeRequest = vOutput<typeof createGLCodeSchema>

export type GLCodeResponseDTO = {
  glCodes: AccountGLCode[]
  alreadyExists?: boolean
}

export class AccountGLCode {
  _id: ObjectId
  code: string
  description?: string
  created: Date
  createdBy: ObjectId
}

export const updateLoadGLCodeRequestSchema = vObject({
  glCode: vString(),
})

export type UpdateLoadGLCodeRequest = vOutput<
  typeof updateLoadGLCodeRequestSchema
>
